'use strict';

/* global angular */

var MapDirective = require('./MapDirective');
var InnerDirective = require('./InnerDirective');
var MapPopupDirective = require('./MapPopupDirective');

angular
.module('manager.processingJobs.job.map', [
  'saturn.map'
])
.directive('map', MapDirective)
.directive('inner', InnerDirective)
.directive('mapPopupContent', MapPopupDirective);



// WEBPACK FOOTER //
// ./src/app/manager/processing/map/index.js